export class Token {
    public accessToken: string;

    public constructor(init?: Partial<Token>) {
        Object.assign(this, init);
    }
}